import useSuccess from "../hooks/useSuccess";
import useRemoteAssets from "../utils/useRemoteAssets";
export default function Success() {
  const {
  handleLogin,
  Button,
  loading,
  authToken,
} = useSuccess();

  const ASSETS = useRemoteAssets();
  if (!ASSETS || loading || !Button) {
    return <div>Loading...</div>;
  }
  return (
    <div className="w-full max-w-[280px] md:max-w-[511px] mx-auto min-h-[30vh] flex flex-col items-center justify-between">

      {/* Success Image */}
      <img
        src={ASSETS.success}
        alt="success"
        className="
          w-[133px]
          h-[114px]

          md:w-[321px]
          md:h-[284px]
        "
      />

      {/* Success Text */}
      <p
        className="
          mt-6
          w-[284px]

          text-[10px]
          leading-[15px]
          font-light
          tracking-[-0.011em]

          md:w-[700px]
          md:text-[16px]
          md:leading-[24px]

          text-black
          text-center
        "
      >

        Congratulations your account
        with Ambit Technology has been
        successfully created

      </p>

      {/* Login Button */}
      <Button
         token={authToken}
        onClick={handleLogin}
        className="
          mt-10
          w-full
          max-w-[280px]
          md:max-w-[300px]

          h-[45px]
          md:h-[51px]

          bg-[#CF0018]
          text-white
          rounded-xl
          font-bold
          font-montserrat
         "
      >

        Login

      </Button>
    </div>
  );
}